if (!customElements.get("collection-color-swatches")) {
  customElements.define(
    "collection-color-swatches",
    class CollectionColorSwatches extends HTMLElement {
      connectedCallback() {
        this.picker =
          this.closest("[data-variant-picker]") ||
          this.closest("variant-radios, variant-selects") ||
          document;
        this.changeHandler = this.updateSwatchLinks.bind(this);
        this.picker.addEventListener("change", this.changeHandler);
        this.updateSwatchLinks();
      }

      disconnectedCallback() {
        this.picker.removeEventListener("change", this.changeHandler);
      }

      getSelectedOptions() {
        const selected = {};
        this.picker
          .querySelectorAll('input[type="radio"]:checked')
          .forEach((input) => {
            selected[input.name] = input.value;
          });
        return selected;
      }

      updateSwatchLinks() {
        const selected = this.getSelectedOptions();
        this.querySelectorAll("a[data-variants]").forEach((link) => {
          const url = link.dataset.productUrl;
          if (!url) return;
          const variant = this.findMatchingVariant(link, selected);
          link.setAttribute(
            "href",
            variant ? `${url}?variant=${variant.id}` : url
          );
        });
      }

      findMatchingVariant(link, selected) {
        let variants, optionNames;
        try {
          variants = JSON.parse(link.dataset.variants);
          optionNames = JSON.parse(link.dataset.optionNames);
        } catch (error) {
          return null;
        }
        const colorOptionName = link.dataset.colorOptionName;
        const matches = variants.filter((variant) =>
          optionNames.every((name, index) => {
            // The color option differs between sibling products by design,
            // and options the current product doesn't have can't constrain.
            if (name === colorOptionName) return true;
            if (!(name in selected)) return true;
            return variant.options[index] === selected[name];
          })
        );
        return (
          matches.find((variant) => variant.available) || matches[0] || null
        );
      }
    }
  );
}
